export default '/build/796ec237.png'